import FieldMixins from './mixins/field_mixin.js';
import FieldListDetail from './list/detail.js';

export default Vue.extend({
  components: {
    FieldList: FieldListDetail,
  },

  mixins: [FieldMixins],

  data() {
    return {
      childOnEditing: false,
    };
  },

  template: `
    <FieldView :editing='editing'
               :field='field'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               ref='fieldView'>
      <template slot='content'>
        <div :class="(editing ? 'edit' : 'display') + '-content'">
          <FieldList :fields='field.children'
                     :exceptions='["Field::Detail"]'
                     :fieldable='field.fieldable'
                     ref='childrenView'
                     @fieldBlured='fieldBlured'
                     @fieldRemoved='fieldRemoved' />
          <div class="justify-between" v-if='editing || childOnEditing'>
            <div class="clickable add-field-btn" @click.stop='addField'>添加字段项</div>
            <div class="right vertical-middle force-no-wrap" v-if='!childOnEditing'>
              <span>按钮名称</span>
              <input type="text"
                     class='detail-btntext-input'
                     placeholder='默认为明细'
                     v-model.trim='field.settings.button_name' />
            </div>
          </div>
          <button v-if='!editing && !childOnEditing'>添加{{ field.settings.button_name }}</button>
        </div>
      </template>
    </FieldView>
  `,

  methods: {
    addField() {
      if (this.editing) {
        this.editing = false;
        this.childOnEditing = true;
        this._removeBackdrop();
      }
      this._addChildField();
    },

    fieldBlured(fieldView, event) {
      if (!this.$el.contains(event.target)) this.childOnEditing = false;
    },

    fieldRemoved() {
      this.childOnEditing = false;
      this.editing = true;
    },

    quitEditing() {
      this.editing = false;
      if (this.childOnEditing) {
        this.childOnEditing = false;
        this.$refs.childrenView.allFieldsQuitEditing();
      }
    },

    validate() {
      if (this._hasChild()) return true;
      this.$emit('fieldError', 'detail', '不能为空');
      return false;
    },

    _hasChild() {
      return this.field.children.length > 0 && _.some(this.field.children, (child) => !child._destroy);
    },

    _addChildField() {
      const field = this.$refs.childrenView.addNewField();
      field.detail_id = this.field.id;
    },

    _enableBackdrop() {
      if (!this.editing) return;
      this._backdrop_id = Skylark.Helpers.App.capturedBackdrop((event) => {
        const fieldView = event.target.closest('.field-view');
        if (fieldView && fieldView.getAttribute('moved')) return { force_clean: false };
        this.editing = false;
        this.childOnEditing = false;
        return undefined;
      }, this.$el);
    },
  },
});
